import { Flex, Form, Input } from 'antd';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { UserInfo } from '@shared/api';

import styles from './personal-details.module.scss';

interface PersonalDetailsProps {
  user: UserInfo;
}

export const PersonalDetails: FC<PersonalDetailsProps> = ({ user }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'profile.user.personal',
  });
  const emptyValue = t('emptyValue');

  return (
    <Form layout="vertical" className={styles.root}>
      <Flex gap={16} className={styles.row}>
        <Form.Item label={t('fullName')} className={styles.field}>
          <Input value={user.full_name || emptyValue} readOnly size="large" />
        </Form.Item>

        <Form.Item label={t('email')} className={styles.field}>
          <Input value={user.email || emptyValue} readOnly size="large" />
        </Form.Item>
      </Flex>

      <Form.Item label={t('phone')}>
        <Input value={user.phone || emptyValue} readOnly size="large" />
      </Form.Item>
    </Form>
  );
};
